"use client";

import React, { useEffect, useState, useRef } from "react";
interface StatData {
  label: string;
  value: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
}
const statsData: StatData[] = [{
  label: "Institutional Volume",
  value: 4.2,
  prefix: "$",
  suffix: "B+",
  decimals: 1
}, {
  label: "Avg Execution Speed",
  value: 12,
  suffix: "ms",
  decimals: 0
}, {
  label: "Global Traders",
  value: 2.5,
  suffix: "M+",
  decimals: 1
}, {
  label: "System Reliability",
  value: 99.99,
  suffix: "%",
  decimals: 2
}];
function CountUp({
  end,
  prefix = "",
  suffix = "",
  decimals = 0
}: {
  end: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
}) {
  const [value, setValue] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    let startTimestamp: number;
    const duration = 2500;
    const step = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      setValue(end * easeOutQuart);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        setValue(end);
      }
    };
    window.requestAnimationFrame(step);
  }, [end, isVisible]);
  return <span ref={ref}>
      {prefix}
      {value.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      {suffix}
    </span>;
}
export default function MarketImpactStats() {
  return <section data-section-id="133281" id="real-time-performance" className="dark bg-background text-foreground relative overflow-hidden py-16 border-y border-border/20">
      {}
      <style>{`
        @keyframes scan-line {
          0% { transform: translateY(-10px); opacity: 0; }
          5% { opacity: 1; }
          95% { opacity: 1; }
          100% { transform: translateY(100vh); opacity: 0; }
        }
      `}</style>

      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
        <div className="w-full h-[2px] bg-primary/40 shadow-[0_0_15px_4px_var(--primary)]" style={{
        animation: "scan-line 6s linear infinite"
      }} />
        {}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9InJnYmEoMCwyMzgsMjU1LDAuMDgpIi8+PC9zdmc+')] opacity-20" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 sm:divide-x divide-border/10">
          {statsData.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center py-8 lg:py-6 px-6 text-center group">
              <h3 className="text-xs md:text-sm font-sans font-semibold text-muted-foreground uppercase tracking-[0.25em] mb-4 group-hover:text-primary transition-colors duration-300">
                {stat.label}
              </h3>
              <div className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-foreground font-mono drop-shadow-[0_0_20px_rgba(0,238,255,0.15)]">
                <CountUp end={stat.value} prefix={stat.prefix} suffix={stat.suffix} decimals={stat.decimals} />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}